module.exports = __webpack_public_path__ + "static/media/cert_157.5713dda1.jpg";